import { owaComputedFn } from 'owa-computed-fn';
import { getSelectedTableView } from 'owa-mail-list-store';
import { isArchiveNotesFolder } from 'owa-folders';

/**
 * Returns true when the currently selected folder is the non-default notes (sticky note) folder
 * synced for an archive mailbox (see isArchiveNotesFolder for details). Mail item actions
 * (reply, forward, delete, etc.) are not supported for the archive notes folder, so this is
 * used to disable those ribbon buttons.
 */
export const isNotesFolderSelected: () => boolean = owaComputedFn(
    function isNotesFolderSelected(): boolean {
        const folderId = getSelectedTableView()?.tableQuery?.folderId;
        return isArchiveNotesFolder(folderId);
    }
);
